import { tv } from "../../variants/tv.js";
const reviewScoreVariants = tv({
    slots: {
        rootSlot: 'inline-flex items-center',
        badgeSlot: 'shrink-0',
        contentSlot: 'flex flex-col items-start justify-center',
        verbiageSlot: 'text-body3 font-bold text-neutral-13',
        reviewLineSlot: 'flex items-center gap-1 text-body3 font-medium',
        reviewTextSlot: 'shrink-0 whitespace-nowrap text-neutral-13',
        separatorSlot: 'shrink-0 text-neutral-13',
        dataSlot: 'text-neutral-13'
    },
    variants: {
        size: {
            xs: {
                rootSlot: 'gap-1',
                verbiageSlot: 'hidden'
            },
            sm: {
                rootSlot: 'gap-2'
            },
            md: {
                rootSlot: 'gap-2'
            }
        },
        truncateData: {
            true: {
                rootSlot: 'max-w-full',
                contentSlot: 'min-w-0',
                reviewLineSlot: 'w-full min-w-0 overflow-hidden',
                dataSlot: 'min-w-0 truncate'
            }
        }
    },
    defaultVariants: {
        size: 'md'
    }
});
const reviewScoreSizes = Object.keys(reviewScoreVariants.variants.size);
export { reviewScoreSizes, reviewScoreVariants };
